export default __webpack_public_path__ + "static/media/think.b2ae8a52.svg";